<template>
    <div class="container-md container-app p-0 ">
        <div class="wrapper">
            <div class="header"><h1>{{$t('account.gestione_indirizzi')}}</h1></div>
            <div class="content content-full">
                <form>
                    <div class="title">{{$t('carrello_indirizzo_consegna')}}</div>
                    <div class="container">
                        <div class="row-sezione">
                            <a type="button" class="btn btn-block"
                                    @click="openEditModal(null)"
                                    :disabled="this.loading_visible">
                              <div class="d-flex justify-content-between align-items-center" >
                                <div class="d-flex align-items-center">
                                  <span class="material-symbols-outlined">
                                  home_pin
                                  </span><div class="pl-2" style="font-weight:500"> {{$t('account.nuovo_indirizzo_consegna')}}</div>
                                </div>
                                <i class="pi pi-plus"></i>
                              </div>
                            </a>
                            <div class="blocchetto p-0" v-for="(address, i) in this.addresses">
                                <div class="d-flex justify-content-between">
                                  <a href="#" @click.prevent="openEditModal(address)" class="a1 flex-grow-1 p-2">
                                    <span v-if="address.campanello">
                                        {{$t('account.campanello')}}: {{address.campanello}}
                                        <br>
                                    </span>
                                    {{address.indirizzo}}, {{address.numero}}
                                    <span v-if="address.cap_zona"><br>{{address.cap_zona}}</span>
                                    <span v-else><br>{{address.cap_citta}}</span>
                                    {{address.localita_citta}}
                                    <span v-if="address.localita_zona">
                                        <br>{{$t('zona')}}: {{address.localita_zona}}
                                    </span>
                                  </a>
                              <div class="d-flex flex-column align-items-stretch">
                                    <a href="#" @click.prevent="openEditModal(address)">
                                      <div class="d-flex align-items-center align-items-stretch bg-color-dark my-0" style="padding: 6px; border-radius: 0 5px 0 0;">
                                        <span class="material-symbols-outlined icone40" v-tooltip:bottom="$t('modifica')">
                                        edit
                                        </span>
                                      </div>
                                    </a>
                                    <a href="#" @click.prevent="openDeleteModal(address)">
                                      <div class="d-flex align-items-center align-items-stretch bg-button-delete my-0" style="padding: 6px;">
                                        <span class="material-symbols-outlined icone40" v-tooltip:bottom="$t('elimina')">
                                        delete
                                        </span>
                                      </div>
                                    </a>
                                </div>
                                </div>
                              <div class="border-top">
                              <mcw-radio v-model="predefined_address_id" name="predefinito" :id="'address_'+i"
                                         :label="$t('carrello_predefinito')" :value="address.id.toString()"
                                         class="pb-2 pt-0 pl-2"/>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="container d-none d-md-block">
                      <hr>
                        <div class="row-sezione d-flex justify-content-center">
                            <router-link :to="{name:'user'}">
                                <button type="button" class="btn btn-default">{{$t('btn_indietro')}}</button>
                            </router-link>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <!-- modals -->
        <modal-address v-if="this.show_address_modal"
                       @close="closeAddressModal"
                       :delivery-cities="this.delivery_cities"
                       :delivery-configuration="this.delivery_configuration"
                       :address="this.selected_address"
                       :countries="this.countries"
        />

        <modal-confirm :header-title="$t('attenzione_label')"
                       :body-text="$t('confirm_remove_address')"
                       v-if="this.show_delete_modal"
                       @close="closeDeleteModal"/>

        <modal v-if="this.show_management_modal"
               :show-title="true"
               size="medium"
               @close="show_management_modal = false">
            <div slot="header">
                <h5 class="modal-title">{{$t('attenzione_label')}}</h5>
            </div>
            <div slot="body">
                {{$t('address_management_changed')}}
            </div>
        </modal>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';

    import {getMixedInfo} from "../../api/restaurant";
    import {deleteDeliveryAddress, getDeliveryAddresses, setDefaultDeliveryAddress} from "../../api/account";
    import {getCountries} from "../../api/mixed";

    import ModalConfirm from "../partials/ModalConfirm";
    import Modal from "../partials/Modal";
    import ModalAddress from "./partials/ModalAddress";

    export default {
        name: "Addresses",
        components: {ModalAddress, Modal, ModalConfirm},
        data() {
            return {
                addresses: [],
                delivery_configuration: null,
                delivery_cities: [],
                predefined_address_id: '',
                selected_address: null,

                //delete modal
                show_delete_modal: false,

                //address management modal
                show_management_modal: false,

                //address modal
                show_address_modal: false,

                //countries
                countries: []
            }
        },
        created() {
            this.fetch();
        },
        computed: {
            ...mapState('global', {
                loading_visible: state => state.loading_visible
            }),
            ...mapState('localization', {
                language: state => state.language
            }),
            ...mapState('auth', {
                user: state => state
            }),
            ...mapState('restaurant', {
                id_ristorante: state => state.id,
                locale: state => state.locale
            })
        },
        watch: {
            //non so se sia il metodo più corretto
            predefined_address_id: function (new_id) {
                const predefinedAddress = this.addresses.find((address) => {
                    return address.predefinito;
                });

                if (predefinedAddress) {
                    if (predefinedAddress.id != new_id) {
                        this.setDefault();
                    }
                }
            }
        },
        methods: {
            fetch: function () {
                this.showLoading(true);
                axios.all([
                    getMixedInfo(this.language, {
                        id_ristorante: this.id_ristorante,
                        id_locale: this.locale.id,
                        api_key: this.user.api_key,
                        configurazione_delivery: true,
                        consegne_citta: true
                    }),
                    getDeliveryAddresses(this.language, {
                        id_ristorante: this.id_ristorante,
                        email: this.user.email,
                        api_key: this.user.api_key
                    }),
                    getCountries(this.language, {})
                ]).then(axios.spread((...responses) => {
                    const responseInfo = responses[0];
                    const responseAddresses = responses[1];
                    const responseCountries = responses[2];

                    this.delivery_configuration = responseInfo.configurazione_delivery;
                    this.delivery_cities = responseInfo.consegne_citta.filter((city) => {
                        return city.tipo === this.delivery_configuration.tipo_modalita_zone;
                    });

                    this.addresses = responseAddresses.indirizzi;

                    const predefinedAddress = this.addresses.find((address) => {
                        return address.predefinito;
                    });

                    if (predefinedAddress) {
                        this.predefined_address_id = predefinedAddress.id.toString();
                    }

                    this.countries = responseCountries.countries;

                })).catch(({messages}) => {
                    alert(messages.join('\n'));
                }).finally(() => {
                    this.showLoading(false);
                });
            },
            setDefault: function () {
                this.showLoading(true);
                setDefaultDeliveryAddress(this.language, {
                    id_ristorante: this.id_ristorante,
                    email: this.user.email,
                    api_key: this.user.api_key,
                    id_indirizzo: this.predefined_address_id
                }).then(() => {
                    //setto il nuovo indirizzo come predefinito
                    this.addresses = this.addresses.map((address) => {
                        return {
                            ...address,
                            predefinito: address.id == this.predefined_address_id ? 1 : 0
                        }
                    });
                }).catch(({messages}) => {
                    alert(messages.join('\n'));
                }).finally(() => {
                    this.showLoading(false);
                })
            },
            openDeleteModal: function (address) {
                this.selected_address = address;
                this.show_delete_modal = true;
            },
            closeDeleteModal: function (remove) {
                if (remove) {
                    this.showLoading(true);
                    deleteDeliveryAddress(this.language, {
                        id_ristorante: this.id_ristorante,
                        email: this.user.email,
                        api_key: this.user.api_key,
                        id_indirizzo: this.selected_address.id
                    }).then(() => {
                        this.addresses = this.addresses.filter((address) => {
                            return address.id !== this.selected_address.id;
                        });

                        if (this.selected_address.predefinito) {
                            this.predefined_address_id = null;
                        }

                    }).catch(({messages}) => {
                        alert(messages.join('\n'));
                    }).finally(() => {
                        this.showLoading(false);
                        this.selected_address = null;
                    });
                }

                this.show_delete_modal = false;
            },
            openEditModal: function (address) {
                this.selected_address = address;

                if (this.selected_address && (
                    !address.consegna_citta || (
                        this.delivery_configuration.tipo_modalita_zone !== address.consegna_citta.tipo
                    )
                )
                ) {
                    this.show_management_modal = true;
                } else {
                    this.show_address_modal = true;
                }
            },
            closeAddressModal: function (address) {
                if (address) {
                    this.fetch();
                }
                this.show_address_modal = false;
            },
            ...mapActions('global', [
                'showLoading'
            ])
        }
    }
</script>
